import {
  anUpdateRuleEnabled,
  mockUpdateRuleEnabledOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const updateRuleEnabledResponse = {
  __typename: 'Mutation' as const,
  updateRuleEnabled: anUpdateRuleEnabled({ ok: true }),
};

export const handlers = [
  mockUpdateRuleEnabledOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: updateRuleEnabledResponse,
      });
    }
  ),
];
